module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "9087.b03046cc.jpg";